module.exports = __webpack_public_path__ + "static/PrimitiveOne-0da4b5e952e5b77ab981b190c7cf1407.png";